import * as Yup from "yup";

export enum CompanyFormHeader {
  add = "Add Company",
  edit = "Edit Company",
}

export const StatusOptions = ["Active", "Inactive"] as const;

export const CompanyFormSchema = Yup.object({
  status: Yup.string()
    .oneOf([...StatusOptions])
    .defined("Required"),
  name: Yup.string().required("Required"),
  address: Yup.string().required("Required"),
  entityId: Yup.string().required("Required"),
});

export type CompanyFormType = Yup.TypeOf<typeof CompanyFormSchema>;
